// src/layouts/Sidebar.tsx
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { sidebarMenu } from '@/config/config';
import { logout } from '@/utils/common';
import { getUser } from '@/utils/auth';
import { USER_ROLES } from '@/utils/common';

/* ===== CHECK QUYỀN ===== */
const canAccess = (
  user: any,
  permission?: string,
  adminOnly?: boolean
) => {
  if (!user) return false;

  // menu chỉ admin
  if (adminOnly) return user.role == USER_ROLES.ADMIN;

  // admin full quyền
  if (user.role ==USER_ROLES.ADMIN) return true;

  // menu không yêu cầu quyền
  if (!permission) return true;

  return user.permissions?.includes(permission);
};

/* ===== FILTER MENU ===== */
const filterMenuByPermission = (menu: any[], user: any) => {
  return menu
    .map((item) => {
      if (item.submenu) {
        const filteredSub = item.submenu.filter((sub: any) =>
          canAccess(user, sub.permission, sub.adminOnly)
        );

        if (filteredSub.length === 0) return null;

        return { ...item, submenu: filteredSub };
      }

      if (!canAccess(user, item.permission, item.adminOnly)) return null;

      return item;
    })
    .filter(Boolean);
};

/* ===== SIDEBAR ITEM ===== */
const SidebarItem = ({
  icon,
  label,
  path,
  submenu,
  sidebarOpen,
  locationPath,
}: any) => {
  const [openSubmenu, setOpenSubmenu] = useState(false);
  const isActive = path && locationPath === path;

  if (submenu) {
    return (
      <div>
        <div
          onClick={() => setOpenSubmenu(!openSubmenu)}
          className="flex items-center px-3 py-2 rounded-xl cursor-pointer text-gray-400 hover:text-blue-400"
        >
          <i className={`${icon} text-lg`}></i>
          {sidebarOpen && <span className="ml-3">{label}</span>}
          {sidebarOpen && (
            <i className={`ri-arrow-down-s-line ml-auto ${openSubmenu ? 'rotate-180' : ''}`}></i>
          )}
        </div>

        {sidebarOpen && openSubmenu && (
          <div className="ml-6 space-y-1">
            {submenu.map((sub: any) => (
              <Link
                key={sub.path}
                to={sub.path}
                className={`block px-3 py-2 text-sm rounded-xl ${
                  locationPath === sub.path
                    ? 'text-blue-400 font-semibold'
                    : 'text-gray-300 hover:text-blue-400'
                }`}
              >
                {sub.label}
              </Link>
            ))}
          </div>
        )}
      </div>
    );
  }

  return (
    <Link
      to={path}
      className={`flex items-center px-3 py-2 rounded-xl ${
        isActive ? 'text-blue-400 font-semibold' : 'text-gray-200 hover:text-blue-400'
      }`}
    >
      <i className={`${icon} text-lg`}></i>
      {sidebarOpen && <span className="ml-3">{label}</span>}
    </Link>
  );
};

/* ===== MAIN SIDEBAR ===== */
export default function Sidebar() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const location = useLocation();
  const  user = getUser(); // 🔥 user login

  const filteredMenu = filterMenuByPermission(sidebarMenu, user);


  return (
    <div className={`bg-gray-900 ${sidebarOpen ? 'w-64' : 'w-20'} transition-all`}>
      <div className="p-4 flex justify-between">
        {sidebarOpen && <h1 className="text-white font-bold">Accord Hotel</h1>}
        <button onClick={() => setSidebarOpen(!sidebarOpen)}>
          <i className="ri-menu-line text-white"></i>
        </button>
      </div>

      <nav className="p-4 space-y-2">
        {filteredMenu.map((item: any, idx: number) => (
          <SidebarItem
            key={idx}
            {...item}
            sidebarOpen={sidebarOpen}
            locationPath={location.pathname}
          />
        ))}
      </nav>

      <div className="p-4">
        <button
          onClick={logout}
          className="flex items-center text-gray-200 hover:text-red-500"
        >
          <i className="ri-logout-box-line"></i>
          {sidebarOpen && <span className="ml-3">Đăng xuất</span>}
        </button>
      </div>
    </div>
  );
}
